( function($) {

	var app = {

		initTabs: function(){
			// Function to show the correct tab
			function showTab(target) {
				$('.ip-shop-tab span a').removeClass('active');
				$('.ip-shop-tab span a[data-tabaccess="' + target + '"]').addClass('active');
				$('.bike-products-category[data-tabpanel]').hide();
				$('.bike-products-category[data-tabpanel="' + target + '"]').show();
			 }
		  
			 // Handle tab click
			 $('.ip-shop-tab span a').on('click', function () {
				var target = $(this).data('tabaccess');
				showTab(target);
				window.location.hash = $(this).attr('href');
			 });
		  
			 // Check the URL hash on page load
			 var hash = window.location.hash;
			 if (hash) {
				var target = $('.ip-shop-tab span a[href="' + hash + '"]').data('tabaccess');
				if (target) {
				    showTab(target);
				}
			 } else {
				// Default to the first tab if no hash is present
				// showTab('All');
                showTab('Land Accessories');
			 }
		},

		
	}

	
	$(document).ready( function() {
		app.initTabs();

	});
	
	$(window).on('load', function(){

	});

})(jQuery);